<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs>
            <!-- 远程控制 -->
            <el-tab-pane>
                <span slot="label"><i class="el-icon-date"></i> 远程控制</span>
                <div class="lie">
                    <table>
                        <tbody>
                            <tr>
                                <td>输入控制命令:</td>
                                <td>
                                    <el-input v-model="input" placeholder=""></el-input>
                                </td>
                            </tr>

                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="tanSend()">查询</el-button>
                                    <el-button type="danger" @click="tanSend()">取消</el-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44",
            }, ],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS",
                },
                {
                    value: "选项2",
                    label: "增加信头标记",
                },
                {
                    value: "选项3",
                    label: "强制TLS",
                },
            ],
            checked: "",
            fileList: [],
            radio: [],
        };
    },
    mounted() {},
    methods: {
        // 显示
        tan: function () {
            this.tanchu = true;
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        },
    },
};
</script>

<style lang="less" scoped>
// input 框高度
/deep/ .el-input__i nner {
    height: 30px;
}

/deep/ .el-tabs--border-card>.el-tabs__content {
    padding: 0;
}

.lie {
    margin: 1%;
    border: 1px solid #ddd;
    width: 98%;
    display: flex;
    justify-content: center;
}

.lie table {
    width: 100%;
}

.lie tbody {
    // width: 100%;
    display: flex;
    flex-direction: column;
    margin: 15px;

    tr {
        border: 1px solid #ddd;
        width: 100%;

        box-sizing: border-box;
        margin-bottom: -1px;
        display: flex;
        align-items: center;

    }
}

/deep/ .el-alert__content {
    padding: 0;
}

.lie tbody td {
    font-size: 14px;
    height: 100%;

}

.lie tbody td:nth-child(1) {
    width: 200px;

    text-align: right;
    padding-right: 20px;
}

.lie tbody td:nth-child(2) {

    display: flex;
    border-left: 1px solid #ddd;

    flex-direction: column;

    .el-input {
        width: 300px;

    }

    padding-left: 20px;

    div {
        padding: 2px 0;
        margin: 4px 0;
    }
}

// 日期
/deep/.el-date-editor .el-range__icon {
    margin-top: -8px;
}

/deep/.el-date-editor span {
    margin-bottom: 8px;
}

/deep/.el-date-editor .el-range__close-icon {
    margin-top: -8px;
}

/deep/ .el-date-editor--datetimerange.el-input__inner {
    width: 300px;
}

//  .el-select .el-input__inner {
//     margin-left: -30px;
// }
.switch {
    border-top: 3px solid #424f63;
    box-shadow: 1px 1px 10px rgba(191, 196, 201, 0.25);
}

// 1
.main {
    display: flex;
    align-items: center;
    border: 1px solid #dcdfe6;
    background: #f1f1f1;
    margin: 20px;

    text-align: left;
    //   margin-top: 20px;
}

.main p {
    padding-left: 10px;
    font-size: 14px;
    line-height: 28px;
}

.main span {
    padding-left: 20px;
}

.el-button {
    padding: 6px;
}

.find2 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    //   height: 300px;
    padding-top: 30px;
    padding-left: 30px;
    width: 50%;
    margin-bottom: 20px;
}

.find2-1 {
    width: 100%;
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    //   justify-content: center;

    div {
        padding: 0 5px;
    }
}

.find2-1 .find-text {
    font-size: 14px;
}

.find2-1 .el-row {
    margin-left: 140px;
}

// input 框高度
/deep/ .el-input__inner {
    height: 26px;
}

// 弹出框1
// 一行
.find {
    display: flex;
    //   flex: 1;
    overflow: auto;
    flex-direction: column;
    text-align: left;
    background: #f1f1f1;
    border: 1px solid #dcdfe6;
    margin-top: 10px;
    padding: 40px 0;
    width: 80%;

    p {
        color: #999;
        font-size: 12px;
        text-align: center;
    }
}

.find1 {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 2px 0;
}

// 文字
.find-text {
    padding: 0 20px;
    font-size: 12px;
}

.el-input {
    // width: 20%;
    padding: 5px 10px 5px 0;
}

/deep/ .el-select {
    // padding-left: 30px;
    width: 222px;
}

// button  按钮
/deep/ .el-button {
    padding: 6px 10px;
    margin-left: 10px;
    margin: 5px 20px;
}

.pop-up {
    position: fixed;
    padding: 20px 0;
    width: 50%;
    //   height: 80%;
    top: 10%;
    left: 25%;
    z-index: 101;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: white;
    //   margin-left: -12.5%;
    //   margin-top: -14%;
}

.gray {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: black;
    opacity: 0.6;
    z-index: 100;
}

// input 框高度
/deep/ .el-input__inner {
    height: 30px;
}

.el-checkbox-group {
    display: flex;
}

.table span {
    font-size: 14px;
}

// th  改高度
/deep/ .el-table th {
    padding: 4px 0;
}

// td  改高度
/deep/ .el-table td {
    padding: 4px 0;
}

/deep/ .cell {
    text-align: center;
}

// 时间
.time {
    display: flex;
    flex-direction: column;
    border: 1px solid #dcdfe6;
    background: #f1f1f1;
    margin: 10px 0;
}

.time1 {
    display: flex;
    align-items: center;
    padding: 2px 0 2px 14px;
    font-size: 14px;
}

// 手动设置
.time-text1 {
    padding-left: 20px;
}

// 后台管理控制
.back {
    display: flex;
    font-size: 14px;
    line-height: 30px;
    align-items: center;
    padding: 6px 0;
}

// .back div {
//   margin: 0 10px;
// }
.back .el-input {
    margin: 0 10px;
}

.backText {
    text-align: right;
}

.backText1 {
    color: #999;
    font-size: 12px;
}

.back .el-input {
    width: 20%;
    padding: 0;
}

.time2 {
    display: flex;
    margin-left: 190px;
    margin-top: 10px;
}

.time2 .el-button {
    padding: 8px 24px;
    // margin: 10px ;
}

// License
.time3 {
    display: flex;
    align-items: center;
    // margin-left: 150px;
    font-size: 14px;
    padding: 4px 10px;
}

// selece
.selece1 {
    width: 130px;
}

// input 框
.back1 .input1 {
    width: 100px;
    margin: 0 10px;
}

// 单选框
.check1 {
    margin: 0 10px;
}

.backText2 {
    margin-left: 40px;
}

.backText3 {
    margin-left: 30px;
}

.back1 .input5-1 {
    width: 100px;
}

.switch1 .table {
    margin-top: 20px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    // padding-left: 50px;
}

.switch1 {
    padding: 0 20px;
    margin-bottom: 20px;
}

.xin {
    width: 98%;
    display: flex;
    flex-direction: column;
    background: #fff;
    margin: 1%;
    border: 1px solid #dcdfe6;
    box-shadow: 0px 0px 10px rgba(68, 73, 78, 0.25);
}

/deep/ .el-tabs__header {
    margin: 0 0 5px;
}

// 三级菜单背景
/deep/ .el-tabs__nav-scroll {
    //   border-bottom: 1px solid #ddd;
    font-size: 12px;
    background: #eee;
    // background: #eee;
}

/deep/ .el-tabs__item {
    color: #333;
    font-size: 14px;
    height: 34px;
    line-height: 34px;
    padding: 0 20px;
    border-left: 1px solid #ddd;
    // border-right: 1px solid #fff;
}

/deep/ .el-tabs__nav-scroll {
    display: flex;
    padding-left: 0px;
    justify-content: space-between;
}

// background: #424F63;
/deep/ .el-tabs__item .is-top {
    font-size: 12px;
}

/deep/ .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding-left: 20px;
    border-left: 0px;
}

/deep/ .el-tabs--top .el-tabs__item.is-top:last-child {
    padding-right: 20px;
}

/deep/ .el-tabs__item.is-active {
    //   color: #409eff;
    background: #fff;
}

/deep/ .el-tabs__active-bar {
    height: 0;
}

// 弹框下的复选框
.el-checkbox:last-of-type {
    margin-right: 10px;
}

@import "../../css/table.less";
</style>
